export default __webpack_public_path__ + "static/zscaler-6340a1100b938588d87e15b40b01413f.jpg";